module.exports = __webpack_public_path__ + "img/IMG pizza.c7205be9.jpg";